import { useLocation } from '@thd-olt-component-react/router';

const useQuery = () => {
  return new URLSearchParams(useLocation().search);
};

export default useQuery;
